<template>
    <div slot="content">
        <div class="table-area">
            <div class="table-b">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name">{{ `고객 리스트` }}</h3>
                    </div>
                    <div class="btn-wrap btn-type1 clearfix">
                        <button class="btn-size btn-gray fl_left" @click="search">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
                        검색
                        </button>
                    </div>
                    <div class="grid-tbl-box">
                        <ag-grid-vue 
                            ref="grid" 
                            :style="gridStyle"
                            class="ag-theme-alpine"
                            row-selection="single"
                            :column-defs="columnDefs"
                            :grid-options="gridOptions"
                            :row-data="data"
                            :default-col-def="defaultColDef"
                            :framework-components="frameworkComponent"
                            @grid-ready="onReadyMain"
                            @cell-clicked="onCellClicked" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * * mixins
 */
 import slip from '@/mixin/slip';
import common from '@/mixin/common';

/**
 * * components
 */
import {AgGridVue} from 'ag-grid-vue';
import DhxCalendar from '@/components/Dhx/DhxCalendar.vue';

export default {
    mixins: [slip, common],
    components: {AgGridVue, DhxCalendar},
    data() {
        return {
            data: [{test1: 'test1'}],
            // AG-GRID OPTION [START]
            gridStyle : 'padding-top: 40px; width: 100%;height: 200px; min-height:100px;',
            defaultColDef: {
                resizable: true
                , filter:false
                , sortable: true
            },
            gridApi: null,
            columnApi: null,
            columnDefs: [],
            gridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            frameworkComponent : {
                
            },
            //AG-GRID OPTION [END]
        }
    },
    methods: {
        onReadyMain() { 
            //메인그리드 api 정의
            this.gridApi = this.gridOptions.api;
            this.columnApi = this.gridOptions.columnApi;
            this.createColumnDefs();
        },
        createColumnDefs() {
            this.columnDefs = [
                {
                    headerName:'No',
                    field:'no', 
                    width:80,
                    cellStyle:{textAlign: 'center'},
                    valueFormatter: function(params) {               
                        return params.node.rowIndex+1;
                    }
                },
            ]
        },
        onCellClicked(params) {
            //const idx = params.rowIndex;
            const field = params.colDef.field;
        },
        search() {

        }
    }
}
</script>